import React, { FC, ReactElement, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { StepperRefProps } from 'src/front/components//StepperView';
import Application from 'src/front/components/Application';
import ViewCreditsProvider from 'src/front/contexts/ViewCreditsContext';
import AllAccountObservationList from './AllAccountObservationList';
import ClientSearch from './ClientSearch';

const AllAccountObservation: FC = () => {
  const { t } = useTranslation();
  const stepperRef = useRef<StepperRefProps>(null);

  const goToNextStep = async (): Promise<void> => {
    stepperRef.current?.goToNextStep();
  };
  const steps = [
    {
      component: () => <ClientSearch goToNextStep={goToNextStep} />,
    },
    {
      component: () => <AllAccountObservationList />,
    },
  ];
  const stepsVertical = useMemo(() => {
    const stepDefinitions = [
      {
        text: t('allAccountObservation_stepper_clientSearch_text'),
      },
      {
        text: t('allAccountObservation_stepper_allAccountObservation_text'),
      },
    ];
    return stepDefinitions.map((item, index) => ({
      text: item.text,
      index: index + 1,
    }));
  }, [t]);

  return (
    <Application stepperRef={stepperRef} steps={steps} stepsVertical={stepsVertical} isCompleted />
  );
};
export default (): ReactElement => (
  <ViewCreditsProvider>
    <AllAccountObservation />
  </ViewCreditsProvider>
);
